// extracted by mini-css-extract-plugin
export default {"buttonsSeparator":"ButtonsSeparator_buttonsSeparator__+ZbuI"};